import { render } from "./attendance-header.vue?vue&type=template&id=e46677b4"
import script from "./attendance-header.vue?vue&type=script&lang=js"
export * from "./attendance-header.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__